import { computed, Signal } from '@angular/core';
import { ThemeService } from './theme';
import { AuthStore } from '../stores/auth.store';
import { AssetAnalysisItem, AssetResponse } from './api';
import { findAnalysisSignal } from '../analysis-data';
import { V3_GUEST_MOCK_ANALYSES } from './v3-guest-mode.mock';

// Finnet guest mode, shared by every V3 component with guest content. Reads AuthStore.token(),
// not AuthBridgeService.token() (AI-553) — only AuthStore covers the ?token= QA/E2E path.
export function v3GuestMode(
  themeService: ThemeService,
  authStore: InstanceType<typeof AuthStore>,
): Signal<boolean> {
  return computed(() => themeService.isFinnet() && !authStore.token());
}

// Guest fallback for the analysts potential-% — guests get no live price to compute it from.
export const V3_GUEST_MOCK_POTENTIAL = 12.4;

export function guestFallbackPotential(real: number | null, isGuestMode: boolean): number | null {
  return real ?? (isGuestMode ? V3_GUEST_MOCK_POTENTIAL : null);
}

// findAnalysisSignal plus the guest fallback: the portal endpoint returns restricted stubs
// ({ restricted: true }) for auth-gated types, so guests get the matching mock instead of a
// hidden section. Real public content passes through untouched.
export function findV3AnalysisSignal(
  v2Data: Signal<AssetResponse | null>,
  type: string,
  isGuestMode: Signal<boolean>,
): Signal<AssetAnalysisItem | null> {
  const realAnalysis = findAnalysisSignal(v2Data, type);
  return computed(() => {
    const real = realAnalysis();
    if (isGuestMode() && (!real || real.content?.['restricted'] === true)) {
      return V3_GUEST_MOCK_ANALYSES[type] ?? real;
    }
    return real;
  });
}
